<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel" >
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header"><span>{{ isEntryMode ? "Approval Setup" : "Approval Setup Update" }}</span></v-expansion-panel-title>
                                    <v-expansion-panel-text> 
                                        <v-row class="py-2 no-gutters">
                                            <v-col lg="3" md="3" cols="12">
                                                <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="approval_name_id.value.value"
                                                    :error-messages="approval_name_id.errorMessage.value"
                                                    clearable
                                                    :items="getApprovalNameList"
                                                    :item-title="item => `${item.name}`"   
                                                    autocomplete="off"                                               
                                                    item-value="id"
                                                    @update:modelValue="checkExistingMatrix"
                                                >
                                                    <template #label>
                                                    Approval Matrix Name <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>

                                            <!-- <v-col lg="3" md="3" cols="12">
                                                 <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="department_id.value.value"
                                                    :error-messages="department_id.errorMessage.value"
                                                    clearable
                                                    :items="getHrmDepartmentList"
                                                    :item-title="item => `${item.name}`"
                                                    autocomplete="off"
                                                    item-value="id"
                                                >
                                                    <template #label>
                                                        Department
                                                    </template>
                                                </v-autocomplete>
                                            </v-col> -->

                                            <v-col lg="3" md="3" cols="12">
                                                <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="total_person.value.value"
                                                type="number"
                                                readonly
                                                :error-messages="total_person.value.errorMessage"
                                                >
                                                <template #label>
                                                    Total Person <span class="text-red-accent-4">*</span>
                                                </template>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-table
                                                    density="compact"
                                                    :loading="loading"
                                                    fixed-header
                                                    class="table-dotted-border-bottom"
                                                    style="min-height: 40vh;"
                                                >
                                                    <thead>
                                                    <tr>
                                                        <th style="width: 5%">Sl</th>
                                                       
                                                        <th style="width: 10%">Step No</th>
                                                        <th style="width: 15%">Step Name</th>
                                                        <th style="width: 20%">Employee</th>
                                                        <th style="width: 20%">Department</th>
                                                        <th style="width: 20%">Designation</th>
                                                        <th style="width: 5%">Can Edit</th>
                                                        <th style="width: 5%">Action</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody >
                                                        <tr v-for="(detail, index) in cart" :key="index">
                                                            <td class="text-center py-2">{{ index + 1 }}</td>
                                                            
                                                            <td class="py-2" style="padding: 0px !important;">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                    class="px-2"
                                                                    v-model="detail.sl"
                                                                    type="number"
                                                                    label="Step No"
                                                                    hide-details
                                                                    :error-messages="getDetailError(index, 'sl')"
                                                                    @blur="validateDetailField(index, 'sl', detail.sl)"
                                                                />
                                                            </td>
                                                            <td class="py-2">
                                                                <v-autocomplete
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    v-model="detail.approval_step_name_id"
                                                                    :items="getApprovalStepNames"
                                                                    :item-title="(item) => `${item.name}`"
                                                                    item-value="id"
                                                                    label="Step Name"
                                                                    autocomplete="off"
                                                                    hide-details
                                                                    clearable
                                                                    :error-messages="getDetailError(index, 'approval_step_name_id')"
                                                                    @blur="validateDetailField(index, 'approval_step_name_id', detail.approval_step_name_id)"
                                                                />
                                                            </td>
                                                            <td class="py-2">
                                                                <v-autocomplete
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    v-model="detail.employee_id"
                                                                    :items="getFilteredEmployees(detail.designation_id, detail.department_id)"
                                                                    :item-title="(item) => `${item.code} - ${item.name}`"
                                                                    item-value="id"
                                                                    label="Employee"
                                                                    autocomplete="off"
                                                                    hide-details
                                                                    clearable
                                                                    :error-messages="getDetailError(index, 'employee_id')"
                                                                    @blur="validateDetailField(index, 'employee_id', detail.employee_id)"
                                                                    @update:modelValue="onEmployeeChange(index, detail.employee_id)"
                                                                />
                                                            </td>

                                                            <td class="py-2">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                    class="px-2"
                                                                    v-model="detail.department_name"
                                                                    type="text"
                                                                    label="Department"
                                                                    hide-details
                                                                    disabled=""
                                                                />
                                                            </td>

                                                            <td class="py-2">
                                                                <v-text-field
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                    class="px-2"
                                                                    v-model="detail.designation_name"
                                                                    type="text"
                                                                    label="Designation"
                                                                    hide-details
                                                                    disabled=""
                                                                />
                                                            </td>
                                                            <td class="py-2">
                                                                <v-checkbox
                                                                    v-model="detail.can_edit"
                                                                    density="compact"
                                                                    hide-details
                                                                    color="primary"
                                                                    :true-value="true"
                                                                    :false-value="false"
                                                                />
                                                            </td>
                                                            <td class="py-2 d-flex">
                                                                <v-btn
                                                                    @click="removeDetailRow(index)"
                                                                    variant="tonal"
                                                                    color="primary"
                                                                    v-if="index !== 0 || cart.length > 1"
                                                                >
                                                                    <v-icon
                                                                        color="red"
                                                                        icon="mdi-minus"
                                                                        size="medium"
                                                                    ></v-icon>
                                                                </v-btn>

                                                                <v-btn
                                                                    @click="addDetailRow"
                                                                    variant="tonal"
                                                                    color="primary"
                                                                    v-if="index == cart.length - 1"
                                                                >
                                                                <v-icon
                                                                    color="info"
                                                                    icon="mdi-plus"
                                                                    size="medium"
                                                                ></v-icon>
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-col>
                                        </v-row>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                            <v-row class="pt-2">
                                                <v-col cols="8">
                                                    <v-textarea
                                                    label="Remarks"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="remarks.value.value"
                                                    :error-messages="remarks.errorMessage.value"
                                                    autocomplete="off"
                                                    rows="3"
                                                    clearable
                                                    ></v-textarea>
                                                </v-col>
                                                <v-col lg="2" md="2" cols="12">
                                                    <v-checkbox                            
                                                        label="Active"
                                                        v-model="status.value.value"
                                                        :error-messages="status.errorMessage.value"
                                                        density="compact"
                                                        variant="outlined"
                                                        hide-details
                                                        color="primary"
                                                        class="px-2"
                                                        value="1"
                                                        :true-value="1"
                                                        :false-value="0"
                                                    ></v-checkbox>
                                                    <input v-model="approval_matrix_id.value.value" type="hidden">
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-layout class="justify-end">                                                   
                                                        <v-btn 
                                                                class="bg-brand w-15 ms-2"  
                                                                variant="flat" 
                                                                type="submit"
                                                            >
                                                                {{ isEntryMode ? 'Save' : 'Update' }}
                                                        </v-btn>
                                                    </v-layout>
                                                </v-col>
                                            </v-row>
                                        </v-card-actions>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref, reactive, computed, onMounted } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 

export default {
        components: {
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            isEntryMode: true,  
            data: {},
            remarks: "",
            status: "1",

        }),
        watch: {

        },
        created(){
            if(this.$store.getters.getHrmDesignationList.length === 0) {this.$store.dispatch('getHrmDesignationList');}
            if(this.$store.getters.getHrmDepartmentList.length === 0) {this.$store.dispatch('getHrmDepartmentList');}
            if(this.$store.getters.getHrmEmployeePermissionWiseList.length === 0) {this.$store.dispatch('getHrmEmployeePermissionWiseList', {params:{is_all_branch: true }});}
            if(this.$store.getters.getApprovalStepNames.length === 0) {this.$store.dispatch('getApprovalStepNames');}
            if(this.$store.getters.getApprovalNameList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getApprovalNameList').then((response) => {
                    this.loading = false;
                })
            };
        },
        computed:{
            getHrmDesignationList() {
                return this.$store.getters.getHrmDesignationList;
            },
            getHrmDepartmentList() {
                return this.$store.getters.getHrmDepartmentList;
            },
            getHrmEmployeePermissionWiseList() {
                return this.$store.getters.getHrmEmployeePermissionWiseList;
            },
            getApprovalStepNames() {
                return this.$store.getters.getApprovalStepNames;
            },
            getApprovalNameList(){
                let data = this.$store.getters.getApprovalNameList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            editingApprovalMatrix() {
                // return this.$store.getters.getEditingApprovalMatrix;
                return [];
            }
        },
        methods: {
          getFilteredEmployees(designationId = null, departmentId = null) {
                return this.getHrmEmployeePermissionWiseList.filter(emp => {
                    if (designationId && emp.designation_id !== designationId) return false;
                    if (departmentId && emp.department_id !== departmentId) return false;
                    return true;
                });
            },
            onEmployeeChange(index, employeeId) {
                const row = this.cart[index];
                if (!row) return;

                // 🔴 When employee is cleared
                if (!employeeId) {
                    row.department_name  = null;
                    row.designation_name = null;
                    return;
                }

                const employees = this.getFilteredEmployees();
                const employee = employees.find(e => e.id == employeeId);

                if (!employee) {
                    row.department_name  = null;
                    row.designation_name = null;
                    return;
                }

                // ✅ When employee is selected
                row.department_name  = employee.department?.name || null;
                row.designation_name = employee.designation?.name || null;
            },


            checkExistingMatrix(approvalNameId) {
                // Check if a matrix already exists for this approval name (only when creating new)
                if (!this.approval_matrix_id.value.value && approvalNameId) {
                    const existingMatrix = this.$store.getters.getApprovalMatrixList.find(
                        matrix => matrix.approval_name_id === approvalNameId
                    );
                    if (existingMatrix) {
                        toast.warning('An approval matrix already exists for this approval name. Please edit the existing matrix instead of creating a new one.');
                    }
                }
            },
            closeDialog() {
                this.dialog = false;
                this.data = {};
            },
            resetForm() {
                this.data = {};
            },
        },
      
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    approval_name_id: yup.number().positive().integer().required().label('Approval Name'),
                    // department_id: yup.number().positive().integer().nullable().label('Department'),
                }),
            });

            const approval_name_id = useField('approval_name_id');
            const department_id = useField('department_id');
            const total_person = useField('total_person');
            const designation_id = useField('designation_id');
            const employee_id = useField('employee_id');

            const remarks = useField('remarks');
            const status = useField('status');
            status.value.value = 1;
            remarks.value.value = '';

            const detailErrors = reactive({});
            const errorMessages = ref("");

            const approval_matrix_id = useField('approval_matrix_id');    
                        
            const cart = ref([
                {
                    designation_id: null,
                    designation_name: "",
                    department_name: "",
                    sl: "",
                    approval_step_name_id: null,
                    department_id: null,
                    employee_id: null,
                    can_edit: false,
                },
            ]);

            total_person.value.value = cart.value.length;
            
            const addDetailRow = () => {
                cart.value.push({
                    designation_id: null,
                    designation_name: "",
                    department_name: "",
                    sl: "",
                    approval_step_name_id: null,
                    department_id: null,
                    employee_id: null,
                    can_edit: false,
                });
                total_person.value.value = cart.value.length;
            };

            const removeDetailRow = (index) => {
                if (cart.value.length > 1) {
                    cart.value.splice(index, 1);
                    delete detailErrors[index];
                    const newErrors = {};
                    Object.keys(detailErrors).forEach((key) => {
                    const idx = parseInt(key);
                    if (idx > index) {
                        newErrors[idx - 1] = detailErrors[key];
                    } else if (idx < index) {
                        newErrors[idx] = detailErrors[key];
                    }
                    });
                    Object.keys(detailErrors).forEach((key) => delete detailErrors[key]);
                    Object.assign(detailErrors, newErrors);
                    total_person.value.value = cart.value.length;
                }
            };
            

            const loading  = ref('');
            const isEntryMode = ref(true);

            const store = useStore();
            const router = useRouter();
            const validateDetailField = (index, field, value) => {
                if (!detailErrors[index]) {
                    detailErrors[index] = {};
                }

                detailErrors[index][field] = "";

                switch (field) {
                    
                    case "approval_step_name_id":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Step Name must be needed";
                        }
                        break;

                    case "employee_id":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Employee must be needed";
                        } else {
                            const duplicate = cart.value.some((detail, idx) =>
                                idx !== index && detail.employee_id == value
                            );
                            if (duplicate) {
                                detailErrors[index][field] = "Employee must be unique";
                            }
                        }
                        break;

                    case "sl":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "SL must be needed";
                        } else {
                            const duplicate = cart.value.some((detail, idx) =>
                                idx !== index && detail.sl == value
                            );
                            if (duplicate) {
                                detailErrors[index][field] = "SL must be unique";
                            }
                        }
                        break;

                    // case "min_amount":
                    //     if (!value || String(value).trim().length < 1) {
                    //         detailErrors[index][field] = "Minimum amount must be needed";
                    //     }
                    //     break;

                    // case "max_amount":
                    //     if (!value || String(value).trim().length < 1) {
                    //         detailErrors[index][field] = "Maximum amount must be needed";
                    //     }
                    //     break;
                }
            };

            const getDetailError = (index, field) => {
                return detailErrors[index] && detailErrors[index][field]
                ? [detailErrors[index][field]]
                : [];
            };

            const validateAllDetails = () => {
                let isValid = true;
                cart.value.forEach((detail, index) => {
                  
                    validateDetailField(index, "approval_step_name_id", detail.approval_step_name_id);
                    validateDetailField(index, "employee_id", detail.employee_id);
                    validateDetailField(index, "sl", detail.sl);

                    if (detailErrors[index]) {
                    Object.values(detailErrors[index]).forEach((error) => {
                        if (error) isValid = false;
                    });
                    }
                });

                return isValid;
            };
            const submit = handleSubmit((values) => {
                if (!validateAllDetails()) {
                    toast.error("Please fix detail validation errors before submitting");
                    return;
                }

                values.status = status.value.value ? 1 : 0;
                const maxSl = Math.max(...cart.value.map(detail => Number(detail.sl) || 0));
              
                values.cart = cart.value.map(detail => ({
                    designation_id: detail.designation_id,
                    department_id: detail.department_id,
                    approval_step_name_id: detail.approval_step_name_id,
                    employee_id: detail.employee_id,
                    designation_name: detail.designation_name,
                    department_name: detail.department_name,
                    sl: detail.sl,
                    can_edit: detail.can_edit,
                    is_final_step: Number(detail.sl) === maxSl,
                }));

                store.dispatch("saveUpdateApprovalMatrix", values)
                    .then((response) => {  
                        resetForm();
                        loading.value = false;
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        setTimeout(() => {
                            router.push({ name: "my-approval" });
                        }, 2000);
                    })
                    .catch((error) => { 
                        loading.value = false;
                        toast.error(error.response.data.message);      
                    })
            })
            onMounted(() => {
                const id = router.currentRoute.value.query.id;
                if (id) {
                    store.commit("SET_LOADING", { color: "primary" });
                    store.dispatch("getApprovalMatrixById", id).then((matrix) => {
                        isEntryMode.value = false;
                        approval_matrix_id.value.value = matrix.id;
                        approval_name_id.value.value = matrix.approval_name_id;
                        total_person.value.value = matrix.total_person;
                        remarks.value.value = matrix.remarks;
                        status.value.value = matrix.status;
                        if(matrix.details.length > 0) {
                            cart.value = [];
                        }

                        (matrix.details || []).forEach((item) => {
                            cart.value.push({
                                designation_id: item.designation_id,
                                department_id: item.department_id,
                                approval_step_name_id: item.approval_step_name_id,
                                sl: item.sl,
                                employee_id: item.employee_id,
                                can_edit: item.can_edit == '1' ? true : false,
                                is_final_step: item.is_final_step == '1' ? true : false,
                            });
                        });
                        store.commit("UNSET_LOADING");
                    }).catch((error) => {
                        store.commit("UNSET_LOADING");
                        console.error("Failed to fetch receive:", error);
                    });
                }
            });
            return {
                submit,
                approval_name_id,
                department_id,
                designation_id,
                employee_id,
                total_person,
                cart,
                addDetailRow,
                removeDetailRow,
                remarks,
                status,
                errorMessages,
                isEntryMode,
                resetForm,
                approval_matrix_id,
                loading,
                detailErrors,
                validateDetailField,
                getDetailError,
                validateAllDetails,
            }
        },

        beforeUnmount() {
            this.$store.commit('UNSET_APPROVAL_MATRIX_LIST');
        },
    }
</script>